import { Dispatch, SetStateAction } from 'react';

import Modal from '../Modal';
import SendToggleForm from './SendToggleForm';

type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  code: string | null;
  firstName?: string | null;
  lastName?: string | null;
};

const SendReferralLink = ({ isOpen, setIsOpen, code, firstName, lastName }: Props) => {
  const onModalClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onModalClose} size="2xl" title="Share Your Referral Link">
      <SendToggleForm code={code || ''} firstName={firstName || ''} lastName={lastName || ''} />
    </Modal>
  );
};

export default SendReferralLink;
